// extracted by mini-css-extract-plugin
module.exports = {"content":"LeaveQuestionForm_content__o8GiK","form":"LeaveQuestionForm_form__sW2Ll"};